import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import MuiAvatar from '@material-ui/core/Avatar';
import React, { memo, useLayoutEffect, useMemo, useState } from 'react';
import Badge from "@material-ui/core/Badge";
import Tooltip from "@material-ui/core/Tooltip";
import classNames from 'classnames';
import useStyles from './styles';
import { listColor } from '../utils/constants';

var getColor = function (str) {
  if (str === void 0) {
    str = '';
  }

  return listColor[str.charCodeAt(0) % listColor.length];
};

var getLetter = function (str) {
  var _str, _str$;

  if (str === void 0) {
    str = '';
  }

  return (_str = str) == null ? void 0 : (_str$ = _str[0]) == null ? void 0 : _str$.toUpperCase();
};

var Avatar = function (props) {
  var _classNames;

  var hide = props.hide,
      imgProps = props.imgProps,
      user = props.user,
      src = props.src,
      alt = props.alt,
      helperText = props.helperText,
      tooltipProps = props.tooltipProps,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'right' : _props$placement,
      _props$size = props.size,
      size = _props$size === void 0 ? 'normal' : _props$size,
      className = props.className,
      icon = props.icon,
      children = props.children,
      _props$shadow = props.shadow,
      shadow = _props$shadow === void 0 ? true : _props$shadow,
      onClick = props.onClick,
      color = props.color,
      style = props.style,
      badge = props.badge,
      border = props.border,
      borderStyle = props.borderStyle,
      badgeProps = props.badgeProps,
      rounded = props.rounded,
      square = props.square,
      rest = _objectWithoutPropertiesLoose(props, ["hide", "imgProps", "user", "src", "alt", "helperText", "tooltipProps", "placement", "size", "className", "icon", "children", "shadow", "onClick", "color", "style", "badge", "border", "borderStyle", "badgeProps", "rounded", "square"]);

  var _ref = user || {},
      name = _ref.name,
      avatar = _ref.avatar,
      image = _ref.image,
      img = _ref.img,
      fb_id = _ref.fb_id;

  var imageSrc = useMemo(function () {
    return fb_id ? "https://graph.facebook.com/" + fb_id + "/picture?type=large" : src || avatar || image || img;
  }, [src, avatar, image, img, fb_id]);
  var genColor = useMemo(function () {
    return getColor(alt || name);
  }, [alt, name]);

  var _useState = useState(function () {
    return color;
  }),
      backgroundColor = _useState[0],
      setBackgroundColor = _useState[1];

  useLayoutEffect(function () {
    if (!imageSrc) setBackgroundColor(genColor);
  }, [genColor, imageSrc]);
  var classes = useStyles(props);
  var customClass = classNames(className, classes.root, (_classNames = {}, _classNames[classes[size]] = !!size, _classNames[classes.shadow] = shadow, _classNames[classes.cursor] = onClick, _classNames[classes.border] = border || borderStyle, _classNames));
  if (hide) return null;
  var avatarCom = /*#__PURE__*/React.createElement(MuiAvatar, _extends({}, rest, {
    variant: rounded ? 'rounded' : square ? 'square' : 'circular',
    style: _extends({
      backgroundColor: backgroundColor
    }, style),
    className: customClass,
    src: imageSrc,
    alt: alt || name,
    onClick: onClick,
    imgProps: _extends({
      loading: 'lazy',
      onError: function handleLoadError() {
        if (color) return;
        setBackgroundColor(genColor);
      }
    }, imgProps)
  }), getLetter(alt) || getLetter(name) || icon || children);
  if (helperText) avatarCom = /*#__PURE__*/React.createElement(Tooltip, _extends({
    title: helperText,
    placement: placement
  }, tooltipProps), avatarCom);
  if (badge || badgeProps) avatarCom = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Badge, _extends({
    overlap: "circle",
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    }
  }, badgeProps, {
    badgeContent: badge
  }), avatarCom));
  return avatarCom;
};

export default /*#__PURE__*/memo(Avatar); // @ts-ignore

export var UProps = function () {
  return null;
};